import {connect} from 'react-redux';
import {addDateAction, addAction} from '../../../redux/actions';
import Dates from '../../regularPages/repeatsComponents/datePicker/datePicker';

const Add = ({displayAdd, addDate, add}) => {

	return (
		<div className='add'>
			<div className='addDate'>
				<button onClick={() => displayAdd('.addDate')} className='addEsc'>X</button>
				<h1 className='addDateH' >בחרי תאריך</h1>
				<Dates />
				<button onClick={addDate} className='addDateOkBtn OkBtn' >אישור</button>
			</div>
			<div className='addContent'>
				<button onClick={() => displayAdd('.addContent')} className='addEsc'>X</button>
				<div className='inputsDiv' >
					<div className='textInputsDiv' >
						<input className='addHeader' type='text' placeholder='כותרת' />
						<input className='addDescription' type='text' placeholder='תיאור' />
					</div>
					<div className='imgInputDiv' >
						<label for="image_uploads">בחרי תמונה</label>
						<input type='file' className='imgInput' id="image_uploads" />
						<i className="camera fas fa-solid fa-camera"></i>
					</div>
					<button onClick={add} className='addContentOkBtn OkBtn' >אישור</button>
				</div>
			</div>
		</div>
	)
}

const mapDispatchToProps = (dispatch) => {
  return {
    add: () => dispatch(addAction()),
    addDate: () => dispatch(addDateAction()),
  }
}

export default connect(null, mapDispatchToProps)(Add) 
